import { useMultipleItemsDrag } from 'hooks/use-multiple-items-drag'
import { useSelector } from 'react-redux'
import { editorSelectors } from 'store/features/editor/selectors'
import {
  moveActiveItems,
  getUpdatedItems,
  getDraggableItemsBounds
} from './utils'
import { projectDataThunks } from 'store/features/projectData/thunks'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { useTimelineMagnetize } from 'hooks/use-timeline-magnetize'
import { useGenerateDraggableItems } from './use-generate-draggable-items'
import { dispatch } from 'store'
import useScrollWhenDragging from 'hooks/useScrollWhenDragging'
import { useTimelineContext } from 'context/TimelineContext'
// this hook is for inline drag(horizontal move), not drag and drop
export const useActiveItemsDrag = () => {
  const draggableItems = useGenerateDraggableItems()
  const timelineRulerSliceDuration = useSelector(
    editorSelectors.timelineRulerSliceDuration
  )
  const magnetizingBreakpointsExcludingActive = useSelector(
    projectDataSelectors.magnetizingBreakpointsExcludingActive
  )

  // same line mediaitems only groups go through dndkit (cross-line capable).
  // bail here so vanilla DOM doesn't double handle the same drag.
  const sameLineMultipleActiveMediaIds = useSelector(
    projectDataSelectors.sameLineMultipleActiveMediaIds
  )
  const shoulPreventDrag =
    draggableItems.length <= 1 || sameLineMultipleActiveMediaIds.length > 0

  const { scrollableContainerRef, setIsMultiDragging } = useTimelineContext()

  const { magnetizeDrag, hideMagnetizingLine } = useTimelineMagnetize()

  const onDragStart = () => {
    setIsMultiDragging(true)
  }
  const onDragEnd = () => {
    const updatedItems = getUpdatedItems(
      draggableItems,
      timelineRulerSliceDuration
    )
    dispatch(projectDataThunks.updateTimelineItems(updatedItems))
    hideMagnetizingLine()
    setIsMultiDragging(false)
  }

  const onDragMove = (deltaX: number) => {
    const { maxLeft, minRight } = getDraggableItemsBounds(draggableItems)

    const newDeltaX = magnetizeDrag(
      deltaX,
      maxLeft,
      minRight,
      magnetizingBreakpointsExcludingActive
    )

    moveActiveItems(newDeltaX, draggableItems)
  }

  const { hasDragged, isDragging } = useMultipleItemsDrag(
    draggableItems.map(item => item.node),
    onDragEnd,
    onDragMove,
    onDragStart,
    shoulPreventDrag,
    scrollableContainerRef
  )

  useScrollWhenDragging({
    scrollableContainerRef,
    isDisabled: shoulPreventDrag || !isDragging
  })

  return hasDragged
}
